import Menus from "../Menus";

const HelpTopicGeneral = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
  ]
    
  const multiMenus = [
    {title: null, filter: 'HelpTopicGeneral', moreIds: [3]},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicGeneral